



















// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { ItemPanier } from '@/models/alo/ItemPanier'
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ProduitMenuSimple'  
})
export default class ProduitMenuSimple extends mixins(BasePlat) {
  plat!:AloPlat

  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }

  addItemToPanier() {    
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else this.addToCart(new ItemPanier({plat:this.plat,qty:1,sectionId:this.platSectionId,arboId:this.platArboId}))
  }

  
}
